/* Volti Games — carrusel, cuenta regresiva, ficha de producto, recomendaciones, filtros, ofertas, FAQ y contacto. */
(() => {
  const { d, R, reduce, $, $$, esc, parse, plural, tierMsg, reveal, shelves, showToast } = window.VG;

  /* Carrusel hero: avanza solo después de la primera interacción (scroll, toque, mouse o teclado), así la slide 1 queda como LCP */
  $$('[data-car]').forEach(car => {
    const slides = $$('.slide', car), dots = $('.dots', car); if (!slides.length || !dots) return;
    const DUR = +(car.dataset.dur || 6000); let idx = 0, timer, auto = false;
    car.style.setProperty('--dur', DUR + 'ms');
    slides.forEach((_, i) => dots.insertAdjacentHTML('beforeend', `<button class="dot${i ? '' : ' is-on'}" type="button" role="tab" aria-label="Destacado ${i + 1}" aria-selected="${!i}"></button>`));
    const dotEls = $$('.dot', dots);
    const go = to => {
      idx = (to + slides.length) % slides.length;
      slides.forEach((s, i) => { s.classList.toggle('is-on', i === idx); s.inert = i !== idx; });
      dotEls.forEach((dt, i) => { dt.classList.remove('is-on'); dt.setAttribute('aria-selected', i === idx); });
      void dots.offsetWidth; dotEls[idx].classList.add('is-on');
      if (auto && !reduce && slides.length > 1) { clearTimeout(timer); timer = setTimeout(() => go(idx + 1), DUR); }
    };
    slides.forEach((s, i) => s.inert = i !== 0);
    dotEls.forEach((dt, i) => dt.addEventListener('click', () => go(i)));
    $$('[data-go]', car).forEach(b => b.addEventListener('click', () => go(idx + +b.dataset.go)));
    car.addEventListener('mouseenter', () => { car.classList.add('is-paused'); clearTimeout(timer); });
    car.addEventListener('mouseleave', () => { car.classList.remove('is-paused'); go(idx); });
    car.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(idx + 1); if (e.key === 'ArrowLeft') go(idx - 1); });
    const vp = $('.car__vp', car); let sx = null;
    if (vp) { vp.addEventListener('pointerdown', e => sx = e.clientX); vp.addEventListener('pointerup', e => { if (sx === null) return; const dx = e.clientX - sx; if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); sx = null; }); }
    const EVS = ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel'];
    const start = () => { if (auto) return; auto = true; EVS.forEach(ev => removeEventListener(ev, start)); if (!car.matches(':hover')) { car.classList.remove('is-paused'); go(idx); } };
    car.classList.add('is-paused');
    EVS.forEach(ev => addEventListener(ev, start, { passive: true }));
    go(0);
  });

  /* Cuenta regresiva: fecha editable desde la sección; si está vacía, fin de mes */
  $$('[data-clock]').forEach(clock => {
    let end = clock.dataset.end ? new Date(clock.dataset.end) : null;
    if (!end || isNaN(end)) { const n = new Date(); end = new Date(n.getFullYear(), n.getMonth() + 1, 0, 23, 59, 59); }
    const lb = ['DÍAS', 'HS', 'MIN', 'SEG'];
    const tick = () => {
      const s = Math.max(0, Math.floor((end - new Date()) / 1000));
      const v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
      clock.innerHTML = v.map((x, i) => `<span>${String(x).padStart(2, '0')}<small>${lb[i]}</small></span>`).join('');
    };
    tick(); setInterval(tick, 1000);
  });

  /* Parallax del arte de ofertas */
  const par = $('[data-parallax]');
  if (par && !reduce) {
    let tk = false;
    addEventListener('scroll', () => { if (tk) return; tk = true; requestAnimationFrame(() => { const r = par.getBoundingClientRect(); const k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; par.style.transform = `translateY(${k * -40}px)`; tk = false; }); }, { passive: true });
  }

  /* Ficha de producto */
  const pf = $('[data-pform]'), pData = $('#pData');
  if (pf && pData) {
    const P = JSON.parse(pData.textContent);
    const idIn = $('input[name="id"]', pf), addBtn = $('#addBtn'), buyNow = $('#buyNow');
    let cur = P.variants.find(v => String(v.id) === idIn.value) || P.variants[0];
    let qtyInCart = +(pf.dataset.qty || 0);
    const setTxt = (s, t) => { const el = $(s); if (el) el.textContent = t; };
    const paintBtn = () => {
      if (addBtn) { addBtn.disabled = !cur.available; addBtn.textContent = !cur.available ? 'Agotado' : qtyInCart ? `Agregar otro (${qtyInCart} en el carrito)` : (P.pre ? 'Reservar' : 'Agregar al carrito'); }
      if (buyNow) buyNow.disabled = !cur.available;
      const rm = $('#rmRow'); if (rm) rm.hidden = !qtyInCart;
    };
    const paintV = push => {
      setTxt('#pN', cur.price);
      const o = $('#pO'); if (o) { o.textContent = cur.old || ''; o.hidden = !cur.old; }
      $$('[data-voff]').forEach(el => { el.hidden = !cur.pct; el.textContent = `-${cur.pct}%`; el.classList.remove('d30', 'd40', 'd50', 'd60'); el.classList.add(`d${cur.band}`); });
      setTxt('#acctName', cur.name);
      setTxt('#acctHint', (P.hints || {})[cur.key] || '');
      setTxt('#pD', P.isGame ? `Juego digital · cuenta ${cur.name.toLowerCase()} · entrega por correo` : `${P.kind} · ${cur.name} · entrega por correo`);
      idIn.value = cur.id;
      $$('[data-vid]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.vid) === String(cur.id)));
      paintBtn();
      if (push) history.replaceState(null, '', `${location.pathname}?variant=${cur.id}`);
    };
    d.addEventListener('click', e => {
      const b = e.target.closest('[data-vid]'); if (!b || b.disabled) return;
      const v = P.variants.find(x => String(x.id) === b.dataset.vid); if (!v) return;
      cur = v; paintV(true);
    });
    const paintTier = n => {
      setTxt('#tCount', `${n} ${plural(n, 'juego', 'juegos')} en el carrito`);
      setTxt('#tMsg', tierMsg(n));
      const f = $('#meterF'); if (f) f.style.width = Math.min(n, 4) / 4 * 100 + '%';
      const m = $('#meter'); if (m) m.setAttribute('aria-valuenow', Math.min(n, 4));
      $$('.meter__m', pf).forEach((el, i) => el.classList.toggle('on', n >= i + 2));
    };
    const refreshQty = async () => {
      try { const c = await (await fetch(R.cart + '.js')).json(); qtyInCart = c.items.filter(x => x.product_id === P.pid).reduce((s, x) => s + x.quantity, 0); paintBtn(); return c; } catch (e) { return null; }
    };
    d.addEventListener('vg:cart', e => { paintTier(e.detail.games); refreshQty(); });
    pf.addEventListener('submit', e => { e.preventDefault(); if (cur.available) window.VG.add(cur.id, { from: addBtn, name: P.title }); });
    if (buyNow) buyNow.addEventListener('click', async () => {
      if (!cur.available) return; buyNow.disabled = true;
      const ok = await window.VG.add(cur.id, { from: buyNow, silent: true, name: P.title });
      if (ok) location.href = '/checkout'; else buyNow.disabled = false;
    });
    const rmBtn = $('#rmBtn');
    if (rmBtn) rmBtn.addEventListener('click', async () => {
      const c = await refreshQty(); if (!c) return;
      const l = [...c.items].reverse().find(x => x.product_id === P.pid); if (!l) return;
      try { await window.VG.cartChange(l.key, l.quantity - 1); } catch (er) { showToast(`<div><b>No pudimos actualizar el carrito</b><small>${esc(window.VG.errMsg(er))}</small></div>`); }
    });
    paintV(false);

    /* Galería: caja 3D (gira con el mouse y se balancea sola), carátula e imágenes del producto */
    const galMain = $('#galMain'), galView = $('#galView');
    if (galMain && galView) {
      let view = 'box';
      const paintView = (v, src) => {
        view = v;
        galMain.classList.remove('is-drag'); galMain.style.removeProperty('--ry'); galMain.style.removeProperty('--rx');
        galView.innerHTML = v === 'box'
          ? `<div class="pbox-stage" style="--plat:${P.platColor}"><div class="pbox"><div class="pbox__f pbox__front"><img src="${P.img}" alt="Caja de ${esc(P.title)}"></div><div class="pbox__f pbox__spine"><span>${esc(P.title)}</span></div><div class="pbox__f pbox__top"></div><div class="pbox__f pbox__back"></div></div></div>`
          : `<div class="gal__flat"><img src="${src || P.img}" alt="${esc(P.title)}"></div>`;
      };
      $$('.thumb').forEach(t => t.addEventListener('click', () => { $$('.thumb').forEach(x => x.setAttribute('aria-pressed', x === t)); paintView(t.dataset.v, t.dataset.src); }));
      if (!reduce) {
        galMain.addEventListener('pointermove', e => {
          if (view !== 'box') return;
          const r = galMain.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
          galMain.classList.add('is-drag');
          galMain.style.setProperty('--ry', (8 + px * 48).toFixed(1) + 'deg');
          galMain.style.setProperty('--rx', (12 - py * 14).toFixed(1) + 'deg');
        });
        galMain.addEventListener('pointerleave', () => { galMain.classList.remove('is-drag'); galMain.style.removeProperty('--ry'); galMain.style.removeProperty('--rx'); });
      }
    }
  }

  /* "También te puede gustar": Product Recommendations API */
  $$('[data-recs]').forEach(async sec => {
    try {
      const doc = parse(await (await fetch(sec.dataset.recs)).text());
      const n = $('[data-recs-out]', doc), o = $('[data-recs-out]', sec);
      if (n && o && n.children.length) { o.innerHTML = n.innerHTML; delete o.dataset.bound; shelves(sec); reveal(sec); } else sec.hidden = true;
    } catch (e) { sec.hidden = true; }
  });

  /* Filtros del catálogo (Search & Discovery): se aplican al cambiar */
  $$('[data-filters]').forEach(f => {
    const go = () => { $$('input', f).forEach(i => { if (!i.value || (i.type === 'checkbox' && !i.checked)) i.disabled = true; }); f.submit(); };
    let t;
    f.addEventListener('change', e => { clearTimeout(t); t = setTimeout(go, e.target.type === 'checkbox' ? 0 : 600); });
    f.addEventListener('submit', e => { e.preventDefault(); go(); });
  });
  const side = $('#side');
  if (side) { const mq = matchMedia('(min-width:900px)'); const o = () => { if (mq.matches) side.open = true; }; mq.addEventListener('change', o); o(); }

  /* Preguntas frecuentes por tema */
  const cats = $('[data-fqcats]');
  if (cats) {
    const groups = $$('.fq__g');
    const pick = c => { $$('[data-c]', cats).forEach(b => b.setAttribute('aria-pressed', b.dataset.c === c)); groups.forEach(g => g.hidden = !!c && g.id !== c); reveal(); };
    cats.addEventListener('click', e => { const b = e.target.closest('[data-c]'); if (!b) return; pick(b.dataset.c); history.replaceState(null, '', b.dataset.c ? '#' + b.dataset.c : location.pathname); });
    const h = location.hash.slice(1); if (groups.some(g => g.id === h)) pick(h);
    addEventListener('hashchange', () => { const k = location.hash.slice(1); if (groups.some(g => g.id === k)) pick(k); });
  }

  /* Contacto: validación antes de enviar (el envío lo hace el formulario de Shopify) */
  const cf = $('[data-contact]');
  if (cf) {
    const check = (id, ok) => { const f = $(id); if (f) f.classList.toggle('bad', !ok); return ok; };
    const validate = () => {
      const a = check('#fN', $('#nombre').value.trim().length > 1);
      const b = check('#fE', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($('#correo').value.trim()));
      const c = check('#fM', $('#mensaje').value.trim().length >= 10);
      return a && b && c;
    };
    ['#nombre', '#correo', '#mensaje'].forEach(s => { const el = $(s); if (el) el.addEventListener('input', () => { if (el.closest('.fld').classList.contains('bad')) validate(); }); });
    cf.addEventListener('submit', e => { if (!validate()) { e.preventDefault(); const bad = $('.fld.bad input, .fld.bad textarea', cf); if (bad) bad.focus(); } });
  }
})();